import React from 'react';
import {
  Table,
  TableHeader,
  TableBody,
  DataTableCell,
  TableCell
} from '@david.kucsai/react-pdf-table';
import { CurrencyText } from '../../components';
import { Text } from '@react-pdf/renderer';
import { lightGray } from './pdfStyles';

const styles = {
  tableHead: {
    borderWidth: '0pt',
    backgroundColor: lightGray,
    fontSize: 6,
    fontWeight: 600,
    padding: '2mm 2mm'
  },
  tableCell: {
    borderWidth: '0pt',
    borderBottomColor: lightGray,
    borderBottomWidth: '1pt',
    fontSize: 6,
    padding: '2mm 2mm'
  }
};

export const InvoiceItems = ({ items }) => {
  const tableCellOptions = {
    includeLeftBorder: false,
    includeTopBorder: false,
    includeRightBorder: false,
    includeBottomBorder: false
  };

  const itemsWithTotal = [
    ...items,
    {
      description: 'TOTAL',
      amount: items.reduce((acc, item) => acc + item.amount, 0)
    }
  ];

  return (
    <Table data={itemsWithTotal}>
      <TableHeader {...tableCellOptions}>
        <TableCell style={styles.tableHead}>
          <Text>Item</Text>
        </TableCell>
        <TableCell weighting={0.25} style={{...styles.tableHead, textAlign: 'right' }}>
          <Text>Valor</Text>
        </TableCell>
      </TableHeader>
      <TableBody {...tableCellOptions}>
        <DataTableCell
          style={styles.tableCell}
          getContent={(r) => (
            <Text>
              {r.description}
            </Text>
          )}
        />
        <DataTableCell
          style={{...styles.tableCell, textAlign: 'right'}}
          weighting={0.25}
          getContent={(r) => (
            <Text>
              <CurrencyText value={r.amount} />
            </Text>
          )}
        />
      </TableBody>
    </Table>
  );
};
